export default "__VITE_ASSET__ca664fc9__"